import base64 from './base64';

export default class EmbedCodeGenerator {
  static v2WidgetEmbed(channelId, title, description, related) {
    var template = `
      <div id="boxcast-widget-${channelId}">
      <script type="text/javascript">
      var s = document.createElement('script');
      var a = String.fromCharCode;
      var h = (('https:' == document.location.protocol) ? 'https:' : 'http:');
      s.setAttribute('data-action', 'boxcast-widget-load');
      s.setAttribute('data-handle', '${channelId}');
      s.setAttribute('data-options', 'version=3${title ? '&title=1' : ''}${
      description ? '&description=1' : ''
    }${related ? '&history=1' : ''}');
      s.src = h + '${WIDGET_JS}';
      document.getElementsByTagName('head')[0].appendChild(s);
      </script>
      </div>
    `;
    // XXX: boxcastiframe.com requires a space
    var cleaned = template
      .replace(/^\s+/gm, '')
      .replace(/(?:\r\n|\r|\n)/g, ' ')
      .trim();
    return cleaned;
  }

  static v2IframeEmbed(channelId, title, description, related) {
    var params = base64.encode(
      `'version=3${title ? '&title=1' : ''}${description ? '&description=1' : ''}${
        related ? '&history=1' : ''
      }'`
    );
    var url = `http://boxcastiframe.com/index2.php/?id=${channelId}&widget_params=${params}`;
    var template = `
      <iframe width="720" height="800" src="${url}" frameBorder="0" scrolling="auto" allowfullscreen="true"></iframe>
    `;
    var cleaned = template.replace(/^\s+/gm, '').replace(/(?:\r\n|\r|\n)/g, '');
    return cleaned;
  }

  static v3WidgetEmbed(channelId, args) {
    var embedUrl = BOXCAST_JS_EMBED_URL;
    if (args.version) {
      embedUrl = embedUrl.replace('/v3', `/${args.version}/v3`);
    }
    args = mungeArgs(args);
    const argString = JSON.stringify(args);
    var template = `
      <div id="boxcast-widget-${channelId}"></div>
      <script type="text/javascript" charset="utf-8">
      (function(d, s, c, o) {
      var js = d.createElement(s), fjs = d.getElementsByTagName(s)[0];
      var h = (('https:' == document.location.protocol) ? 'https:' : 'http:');
      js.src = h + '${embedUrl}';
      js.onload = function() { boxcast.noConflict()('#boxcast-widget-'+c).loadChannel(c, o); };
      js.charset = 'utf-8';
      fjs.parentNode.insertBefore(js, fjs);
      }(document, 'script', '${channelId}', ${argString}));
      </script>
    `;
    var cleaned = template
      .replace(/^\s+/gm, '')
      .replace(/(?:\r\n|\r|\n)/g, '')
      .trim();
    return cleaned;
  }

  static v3Highlights(channelId, args) {
    var embedUrl = BOXCAST_JS_EMBED_URL;
    if (args.version) {
      embedUrl = embedUrl.replace('/v3', `/${args.version}/v3`);
    }
    args = mungeArgs(args);
    const argString = JSON.stringify(args);
    var template = `
      <div id="boxcast-widget-${channelId}"></div>
      <script type="text/javascript" charset="utf-8">
      (function(d, s, c, o) {
      var js = d.createElement(s), fjs = d.getElementsByTagName(s)[0];
      var h = (('https:' == document.location.protocol) ? 'https:' : 'http:');
      js.src = h + '${embedUrl}';
      js.onload = function() { boxcast.noConflict()('#boxcast-widget-'+c).loadHighlights(c, o); };
      js.charset = 'utf-8';
      fjs.parentNode.insertBefore(js, fjs);
      }(document, 'script', '${channelId}', ${argString}));
      </script>
    `;
    var cleaned = template
      .replace(/^\s+/gm, '')
      .replace(/(?:\r\n|\r|\n)/g, '')
      .trim();
    return cleaned;
  }

  static v3IframeEmbed(channelId, args) {
    var autoResize = args.iframeResize;
    args = mungeArgs(args);

    var params = [];
    for (var p in args) {
      if (args.hasOwnProperty(p)) {
        var val = args[p];
        if (typeof val !== 'undefined' && val !== null) {
          if (typeof val == 'boolean') {
            val = val ? '1' : '0';
          }
          params.push(encodeURIComponent(p) + '=' + encodeURIComponent(val));
        }
      }
    }
    params = params.join('&');

    var url = `${BOXCAST_JS_IFRAME_URL}/${encodeURIComponent(channelId)}?${params}`;
    var template;
    if (autoResize) {
      // NOTE: the problem with using a script to write the iframe is that CMS's prevent script tags
      // often, which is the usual driver for using iframe embed method.
      template = `
        <script src="https://js.boxcast.com/libs/iframeResizer-3.5.2.min.js"></script>
        <script>(function(p,c,q){
          document.write('<iframe width="100%" id="'+p+c+'" src="${BOXCAST_JS_IFRAME_URL}/'+c+'?'+q+'" frameBorder="0" scrolling="auto" allowfullscreen="true" allow="autoplay; fullscreen"></iframe>');
          iFrameResize({}, '#'+p+c);
        })('boxcast-iframe-', '${channelId}', '${params}&hostname='+encodeURIComponent(location.hostname));
        </script>
      `;
    } else {
      // XXX: TODO: sometimes, the user may just need the `src` value without the <iframe> tag, depending
      // on their web site software. Not sure how we decide when/how to present that option.
      template = `
        <iframe width="720" height="800" src="${url}" frameBorder="0" scrolling="auto" allowfullscreen="true" allow="autoplay; fullscreen"></iframe>
      `;
    }
    var cleaned = template
      .replace(/^\s+/gm, '')
      .replace(/(?:\r\n|\r|\n)/g, '')
      .trim();
    return cleaned;
  }

  static v3Link(channelId, args) {
    var url = BOXCAST_TV_SHOW_URL + channelId;
    // Per Josh M, it's more likely that they just want the link URL and not a fully-formatted
    // anchor tag
    //var template = `
    //  <a href="${url}">View on BoxCast.tv</a>
    //`;
    args = mungeArgs(args);
    const params = args.applyBrandColor === false ? '?applyBrandColor=0' : '';

    var template = `
      ${url}${params}
    `;
    var cleaned = template
      .replace(/^\s+/gm, '')
      .replace(/(?:\r\n|\r|\n)/g, '')
      .trim();
    return cleaned;
  }

  static v3App(channelId, args) {
    args = mungeArgs(args);

    var params = [];
    for (var p in args) {
      if (args.hasOwnProperty(p)) {
        var val = args[p];
        if (typeof val !== 'undefined' && val !== null) {
          if (typeof val == 'boolean') {
            val = val ? '1' : '0';
          }
          params.push(encodeURIComponent(p) + '=' + encodeURIComponent(val));
        }
      }
    }
    params = params.join('&');

    var url = `${BOXCAST_JS_APP_EMBED_URL}#${encodeURIComponent(channelId)}?${params}`;
    return url;
  }

  static v3Rss(channelId, args) {
    const template = `${SYNDICATION_SERVICE_BASE_URL}/rss/${channelId}.rss`;
    return template
      .replace(/^\s+/gm, '')
      .replace(/(?:\r\n|\r|\n)/g, '')
      .trim();
  }

  static v3MRSS(channelId, media, args) {
    const template = `${SYNDICATION_SERVICE_BASE_URL}/mrss/${media}/${channelId}.rss`;
    return template
      .replace(/^\s+/gm, '')
      .replace(/(?:\r\n|\r|\n)/g, '')
      .trim();
  }

  static rokuDirectPublisher(channelId, args) {
    const template = `${SYNDICATION_SERVICE_BASE_URL}/direct-publisher/${channelId}.json`;
    return template
      .replace(/^\s+/gm, '')
      .replace(/(?:\r\n|\r|\n)/g, '')
      .trim();
  }

  static v3Podcast(channelId, media, args) {
    const template = `${SYNDICATION_SERVICE_BASE_URL}/podcasts/${media}/${channelId}.rss`;
    return template
      .replace(/^\s+/gm, '')
      .replace(/(?:\r\n|\r|\n)/g, '')
      .trim();
  }

  static highlightClipEmbed(highlightId, args) {
    var embedUrl = BOXCAST_JS_EMBED_URL;
    args = mungeArgs(args);
    const argString = JSON.stringify(args);
    var template = `
      <div id="boxcast-widget-${highlightId}"></div>
      <script type="text/javascript" charset="utf-8">
      (function(d, s, c, o) {
      var js = d.createElement(s), fjs = d.getElementsByTagName(s)[0];
      var h = (('https:' == document.location.protocol) ? 'https:' : 'http:');
      js.src = h + '${embedUrl}';
      js.onload = function() { boxcast.noConflict()('#boxcast-widget-'+c).loadHighlight(c, o); };
      js.charset = 'utf-8';
      fjs.parentNode.insertBefore(js, fjs);
      }(document, 'script', '${highlightId}', ${argString}));
      </script>
    `;
    var cleaned = template
      .replace(/^\s+/gm, '')
      .replace(/(?:\r\n|\r|\n)/g, '')
      .trim();
    return cleaned;
  }
}

function mungeArgs(options) {
  // Transform the UI options into the ones the player needs
  var args = angular.copy(options);

  if (args.showTitleAndDescription) {
    args.showTitle = 1;
    args.showDescription = 1;
    args.showHighlights = 1;
  } else {
    args.showTitle = 0;
    args.showDescription = 0;
    args.showHighlights = 0;
  }

  if (args.playlistOnRight) {
    args.layout = 'playlist-to-right';
  }

  // Convert string-y truth-y/false-y autoplay options to boolean
  if (args.autoplay === 'true') {
    args.autoplay = true;
  } else if (args.autoplay === 'false') {
    args.autoplay = false;
  }

  // Only pass along the brand color param if it's to disable it
  if (args.applyBrandColor) {
    delete args.applyBrandColor;
  } else {
    args.applyBrandColor = false;
  }

  // Some variables are used by UI but should never be passed along
  delete args.showTitleAndDescription;
  delete args.iframeResize;
  delete args.version;
  delete args.playlistOnRight;

  if (BOXCAST_JS_ENV != 'prod') {
    args.env = BOXCAST_JS_ENV;
  }

  return args;
}



// WEBPACK FOOTER //
// ./app/utils/embed.js